/**
 * Check if the field is rendereable on the summary
 *
 * @param {string} key
 * @return {boolean}
 */
export const isFieldRendereableOnSummary = (
    noDisplayableFilters: string[],
    key: string,
    value: any
) => {
    if (noDisplayableFilters.includes(key)) return false;

    if (Array.isArray(value)) return value.length > 0;

    if (!value) return false;

    return true;
};
